import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

// List of routes where RowDensityMenu should be HIDDEN
// You can add more patterns later
const HIDDEN_ROW_DENSITY_PATTERNS = [
  // /health-monitor/:locationName/details/:locationId
  /^\/health-monitor\/[^/]+\/details\/[^/]+$/,
];

export const useShowRowDensityMenu = () => {
  const { pathname } = useLocation();

  return useMemo(() => {
    const shouldHide = HIDDEN_ROW_DENSITY_PATTERNS.some((regex) => regex.test(pathname));

    return !shouldHide;
  }, [pathname]);
};
